
export default {
  name: 'VehicleHeadlightHeroPinButton',
  props: {
    pinned: {
      type: Boolean,
      default: false,
    },
    pending: {
      type: Boolean,
      default: false,
    },
    failed: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    label() {
      if (this.failed) {
        return this.$t('components.vehicleHeadlightHeroPinButton.failed')
      }
      return this.pinned
        ? this.$t('components.vehicleHeadlightHeroPinButton.unpin')
        : this.$t('components.vehicleHeadlightHeroPinButton.pin')
    },
    hint() {
      return this.pinned
        ? this.$t('components.vehicleHeadlightHeroPinButton.unpinHint')
        : this.$t('components.vehicleHeadlightHeroPinButton.pinHint')
    },
  },
}
